const DEFAULT_GA_MEASUREMENT_ID = 'G-PNMY4BE486'

function getMeasurementId() {
  return process.env.VUE_APP_GA_MEASUREMENT_ID || DEFAULT_GA_MEASUREMENT_ID
}

function ensureDataLayer() {
  window.dataLayer = window.dataLayer || []
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments)
  }
}

export function initializeAnalytics() {
  if (typeof window === 'undefined') return

  const measurementId = getMeasurementId()
  ensureDataLayer()

  if (!document.querySelector(`script[data-ga-id="${measurementId}"]`)) {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
    script.dataset.gaId = measurementId
    document.head.appendChild(script)
  }

  window.gtag('js', new Date())
  window.gtag('config', measurementId, {
    send_page_view: false,
    anonymize_ip: true
  })
}

export function initializeAhrefsAnalytics() {
  if (typeof window === 'undefined') return

  const key = process.env.VUE_APP_AHREFS_ANALYTICS_KEY
  if (!key || document.querySelector('script[data-ahrefs-analytics]')) return

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://analytics.ahrefs.com/analytics.js'
  script.dataset.key = key
  script.dataset.ahrefsAnalytics = 'true'
  document.head.appendChild(script)
}

export function trackPageView(route) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return

  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: route.fullPath
  })
}

export function trackAffiliateClick(product, destinationUrl, placement = 'product_card') {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return

  const rawPrice = product && product.precio ? String(product.precio) : ''
  const value = parseFloat(rawPrice.replace(/[^0-9.]/g, '')) || 0

  window.gtag('event', 'affiliate_click', {
    affiliate_network: getAffiliateNetwork(product, destinationUrl),
    link_url: destinationUrl,
    link_domain: getHostname(destinationUrl),
    link_text: product && product.titulo ? product.titulo : 'View deal',
    item_id: product && product.id ? product.id : '',
    item_name: product && product.titulo ? product.titulo : '',
    item_category: product && product.category ? product.category : '',
    placement,
    currency: 'USD',
    value
  })
}

function getHostname(url) {
  try {
    return new URL(url).hostname
  } catch (error) {
    return ''
  }
}

function getAffiliateNetwork(product, url) {
  if (product && product.affiliateNetwork) return product.affiliateNetwork
  return getHostname(url).includes('amazon.') ? 'amazon_associates' : 'unknown'
}

